import { Inject, Injectable, InjectionToken } from '@angular/core';
import { CacheService } from '@se/se.ui.html5';
import { SecondaryApplicationSettings } from 'estensa-module';
import { Observable, firstValueFrom, from } from 'rxjs';

export const ESTENSA_MODULE_SECONDARY_APPLICATION_SETTINGS_SERVICE = new InjectionToken(
    'estensa.module.secondary.application.settings.service',
);

export interface ISecondaryApplicationSettingsServiceNg1 {
    getAsJSON(): Promise<SecondaryApplicationSettings>;
    isExternalSigningEnabled(): boolean;
}

@Injectable({
    providedIn: 'root',
})
export class SecondaryApplicationSettingsService {
    private _secondarySettings: SecondaryApplicationSettings | null = null;
    get secondarySettings(): SecondaryApplicationSettings | null {
        return this._secondarySettings;
    }
    get secondaryApplicationSettingsAsync(): Observable<SecondaryApplicationSettings> {
        return this.cacheService.get('SecondaryApplicationSettings', from(this.settingsService.getAsJSON()));
    }

    constructor(
        @Inject(ESTENSA_MODULE_SECONDARY_APPLICATION_SETTINGS_SERVICE)
        private settingsService: ISecondaryApplicationSettingsServiceNg1,
        private cacheService: CacheService,
    ) {}

    async initService() {
        if (!this._secondarySettings) {
            return firstValueFrom(this.secondaryApplicationSettingsAsync).then((settings) => {
                this._secondarySettings = settings;
            });
        }
    }
}
